class PseudolinkLoader extends HTMLElement {
  connectedCallback () {
    this.url = this.getAttribute('url')
    this.method = this.getAttribute('method') || 'get'
    this.targets = document.querySelectorAll(this.getAttribute('target'))

    this.onclick = this._doFetch

    this.shots = 'infinite'
    if (this.hasAttribute('shots')) {
      let shots = parseInt(this.getAttribute('shots'))
      this.removeAttribute('shots')
      this.shots = isNaN(shots) ? this.shots : shots
    }

    if (this.hasAttribute('autoclick')) {
      fetch(this.url, { method: this.method, credentials: 'same-origin' })
        .then(function (response) {
          return response.text()
        })
        .then((html) => {
          this._updateTarget(html)
        })

        if (this.targets.length === 1) {
          this.scrollIntoView()
        }
    }
  }

  static get observedAttributes () {
    return ['url']
  }

  attributeChangedCallback (attrName, oldVal, newVal) {
    if (attrName === 'url') {
      this.url = newVal
    }
  }

  _doFetch () {
    if (this.canFire && !this.classList.contains('pseudolink-loader--loading')) {
      this.classList.add('pseudolink-loader--loading')
      fetch(this.url, { method: this.method, credentials: 'same-origin' })
        .then(function (response) {
          return response.text()
        })
        .then((html) => {
          this._updateTarget(html)
          this.classList.remove('pseudolink-loader--loading')
          this._burnOne()
        })
    }
  }

  _updateTarget (html) {
    this.targets.forEach(target => target.innerHTML = html)
  }

  _burnOne () {
    if (!this.infiniteCartriges) {
      --this.shots
    }
  }

  get infiniteCartriges () {
    return this.shots === 'infinite'
  }

  get canFire () {
    return this.infiniteCartriges || this.shots > 0
  }
}

export default PseudolinkLoader
